/**
 * Legal/contact details referenced across the footer and the legal pages
 * (Privacy Policy, Cookie Policy). Single source of truth - these used to be
 * copy-pasted independently into each page, which meant updating them meant
 * hunting down every occurrence and risking missing one. Import from here
 * instead of retyping any of these values.
 *
 * COMPANY_EMAIL is not decoration: the Electronic Commerce (EC Directive)
 * Regulations 2002 require an information society service provider to publish
 * a contact email address that lets people reach it directly, and a contact
 * form on its own is generally not treated as satisfying that. It is also the
 * only working contact route on the site while the Contact form is still a
 * stub, so the legal pages can honour the response commitments they make.
 */

export const COMPANY_NAME = "The Carrot Corporation Ltd";
export const COMPANY_NUMBER = "16853633";
export const COMPANY_EMAIL = "hello@carrotcorp.io";

export const COMPANY_ADDRESS = {
  line1: "19 Westminster Road, Toothill,",
  line2: "Swindon, England,",
  postcode: "SN5 8JF",
};
